import { Component, input, output } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDivider } from '@angular/material/divider';
import {
  MatActionList,
  MatListItem,
  MatListItemIcon,
  MatListItemTitle,
  MatListItemLine,
  MatListItemMeta,
} from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { SlicePipe } from '@angular/common';

export type ListObject = {
  id: number;
  icon: string;
  title: string;
  subtitle: string;
  additional_text: string;
};

@Component({
  selector: 'app-admin-area-list',
  templateUrl: './admin-area-list.component.html',
  styleUrls: ['./admin-area-list.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatPaginator,
    MatDivider,
    MatActionList,
    MatListItem,
    MatIcon,
    MatListItemIcon,
    MatListItemTitle,
    MatListItemLine,
    MatListItemMeta,
    MatButton,
    SlicePipe,
  ],
})
export class AdminAreaListComponent {
  lowValue = 0;
  highValue = 10;

  readonly list = input<ListObject[]>([]);
  readonly objectName = input('');

  readonly objectItemEvent = output<number>();

  objectClicked(object_id: number) {
    this.objectItemEvent.emit(object_id);
  }

  public getPaginatorData(event: PageEvent): PageEvent {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    return event;
  }
}
